import React, { useState, useEffect } from 'react';
import styles from "./avales.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { SERVICE } from '../../utils/constants/services';
import Select from 'react-select'

export default function ModalAval(props) {
    const { show, setShow, roles, dataEdit, setDataEdit, estados, municipios, codigos, handleUpdate, genders } = props;

    const [municipalFilterAval, setMunicipalFilterAval] = useState([]);
    const [postalCodeFilterAval, setPostalCodeFilterAval] = useState([]);
    const [stateSelectAval, setStateSelectAval] = useState(null);
    const [municipalSelectAval, setMunicipalSelectAval] = useState(null);
    const [postalCodeSelectAval, setPostalCodeSelectAval] = useState(null);
    const [gendersSelectAval, setGendersSelectAval] = useState(null);

    const [menu06Data, setMenu06Data] = useState({
        idBacking: 0,
        names: "",
        fathersLastName: "",
        mothersLastName: "",
        dateOfBirth: "",
        credentialNumber: "",
        populationRegistrationCode: "",
        addressDescription: "",
        phoneNumber: "",
        addressReferences: ""
    });

    const handleAgregar = () => {
        if (menu06Data.phoneNumber==="" || menu06Data.addressDescription==="" || menu06Data.populationRegistrationCode==="" || menu06Data.credentialNumber==="" || menu06Data.dateOfBirth==="" || menu06Data.mothersLastName==="" || menu06Data.fathersLastName==="" || menu06Data.names==="" || municipalSelectAval === null || stateSelectAval === null || gendersSelectAval === null || postalCodeSelectAval===null) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            let payload = {
                id: menu06Data.idBacking,
                names: menu06Data.names,
                fathersLastName: menu06Data.fathersLastName,
                mothersLastName: menu06Data.mothersLastName,
                dateOfBirth: menu06Data.dateOfBirth,
                genderId: gendersSelectAval.value,
                stateId: stateSelectAval.value,
                municipalityId: municipalSelectAval.value,
                postalCodeId: postalCodeSelectAval.value,
                credentialNumber: menu06Data.credentialNumber,
                populationRegistrationCode: menu06Data.populationRegistrationCode,
                addressDescription: menu06Data.addressDescription,
                phoneNumber: menu06Data.phoneNumber,
                addressReferences: menu06Data.addressReferences
            }
            let URL = menu06Data.idBacking != 0 ? SERVICE.updateAval : SERVICE.setAval;
            let METHOD = menu06Data.idBacking != 0 ? "PUT" : "POST";
            api(URL, payload, METHOD)
                .then((data) => {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Aval Guardado correctamente",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    setMenu06Data({
                        idBacking: 0,
                        names: "",
                        fathersLastName: "",
                        mothersLastName: "",
                        dateOfBirth: "",
                        credentialNumber: "",
                        populationRegistrationCode: "",
                        addressDescription: "",
                        phoneNumber: "",
                        addressReferences: ""
                    });
                    setStateSelectAval(null);
                    setMunicipalSelectAval(null);
                    setGendersSelectAval(null);
                    setPostalCodeSelectAval(null);
                    handleUpdate();
                    setShow(false);

                })
                .catch((err) => {
                    console.log(err);

                })
        }

    }
    useEffect(() => {
        if (!show && roles.length > 0) {
            // setEmail("");
            // setKey1("");
            // setKey2("");
            // setName("");
            // setLastName("");
            // setUserName("");
            // setRol(roles[0].id);
            // setDataEdit(null);
        }
    }, [show, roles])
    useEffect(() => {
        if (!show) {
            setMenu06Data({
                idBacking: 0,
                names: "",
                fathersLastName: "",
                mothersLastName: "",
                dateOfBirth: "",
                credentialNumber: "",
                populationRegistrationCode: "",
                addressDescription: "",
                phoneNumber: "",
                addressReferences: ""
            });
            setStateSelectAval(null);
            setMunicipalSelectAval(null);
            setPostalCodeSelectAval(null);
            setDataEdit(null);
        }
    }, [show])
    function formatDateForInput(dateString) {
        // Dividir la fecha y hora
        const [datePart] = dateString.split(' ');

        // Dividir día, mes y año
        const [day, month, year] = datePart.split('/');

        // Formatear a YYYY-MM-DD (formato que acepta input date)
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    const handleChangeState = (valueSelect, updateActual = true) => {
        if (valueSelect != null && codigos && codigos.length > 0) {
            if (updateActual) {
                setMunicipalSelectAval(null);
                setPostalCodeSelectAval(null);
            }
            let ArrayTemp = [];
            for (let index = 0; index < municipios.length; index++) {
                const element = municipios[index];
                if (element.stateId === valueSelect.value) {
                    ArrayTemp.push(element);
                }
            }
            setStateSelectAval(valueSelect);
            setMunicipalFilterAval(ArrayTemp);
        }
    }
    const handleChangeMunicipal = (valueSelect, updateActual = true) => {
        if (valueSelect != null && municipios && municipios.length > 0) {
            if (updateActual) {
                setPostalCodeSelectAval(null);
            }
            let ArrayTemp = [];
            for (let index = 0; index < codigos.length; index++) {
                const element = codigos[index];
                if (element.municipalityId === valueSelect.value) {
                    ArrayTemp.push(element);
                }
            }
            setMunicipalSelectAval(valueSelect);
            setPostalCodeFilterAval(ArrayTemp);
        }
    }
    useEffect(() => {
        if (dataEdit != null && show) {
            api(SERVICE.getAvalId + dataEdit.backingId)
                .then((data) => {
                    let dataFull = data.data.data;

                    const [datePart] = dataFull.dateOfBirth.split(' '); 
                    const [day, month, year] = datePart.split('/');
                    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                    setMenu06Data({
                        idBacking: dataFull.id,
                        names: dataFull.names,
                        fathersLastName: dataFull.fathersLastName,
                        mothersLastName: dataFull.mothersLastName,
                        dateOfBirth: formattedDate,
                        credentialNumber: dataFull.credentialNumber,
                        populationRegistrationCode: dataFull.populationRegistrationCode,
                        addressDescription: dataFull.addressDescription,
                        phoneNumber: dataFull.phoneNumber,
                        addressReferences: dataFull.addressReferences,
                    });
                    let search = estados.findIndex(item => item.value == dataFull.stateId);
                    if (search !== -1)
                        handleChangeState(estados[search], false);
                    search = municipios.findIndex(item => item.value == dataFull.municipalityId);
                    if (search !== -1)
                        handleChangeMunicipal(municipios[search], false);
                    search = codigos.findIndex(item => item.value == dataFull.postalCodeId);
                    if (search !== -1)
                        setPostalCodeSelectAval(codigos[search]);
                    search = genders.findIndex(item => item.value == dataFull.genderId);
                    if (search !== -1)
                        setGendersSelectAval(genders[search]);

                })
                .catch((err) => {
                    console.log(err);

                })

        }
    }, [dataEdit, show])
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar Aval" : "Nuevo Aval"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>

                    <div className={styles.containerForm}>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label className="form-label">* Nombre(s):</label>
                            <input type="text" className="form-control" placeholder="Nombre" value={menu06Data.names} onChange={(e) => setMenu06Data({ ...menu06Data, names: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label className="form-label">* A. Paterno:</label>
                            <input type="text" className="form-control" placeholder="A. Paterno" value={menu06Data.fathersLastName} onChange={(e) => setMenu06Data({ ...menu06Data, fathersLastName: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label className="form-label">* A.Materno:</label>
                            <input type="text" className="form-control" placeholder="A.Materno" value={menu06Data.mothersLastName} onChange={(e) => setMenu06Data({ ...menu06Data, mothersLastName: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label className="form-label">* Sexo:</label>
                            <div className={styles.selectContainer}>
                                <Select 
                                    options={genders} 
                                    value={gendersSelectAval} 
                                    onChange={(e) => setGendersSelectAval(e)}
                                    placeholder="Seleccionar sexo..."
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label className="form-label">* Estado:</label>
                            <div className={styles.selectContainer}>
                                <Select 
                                    options={estados} 
                                    placeholder="Seleccionar estado..." 
                                    value={stateSelectAval} 
                                    onChange={(e) => handleChangeState(e)} 
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label className="form-label">* Municipio:</label>
                            <div className={styles.selectContainer}>
                                <Select 
                                    options={municipalFilterAval} 
                                    placeholder="Seleccionar municipio..." 
                                    value={municipalSelectAval} 
                                    onChange={(e) => handleChangeMunicipal(e)} 
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label className="form-label">* Código Postal:</label>
                            <div className={styles.selectContainer}>
                                <Select 
                                    options={postalCodeFilterAval} 
                                    placeholder="Seleccionar código postal..." 
                                    value={postalCodeSelectAval} 
                                    onChange={(e) => setPostalCodeSelectAval(e)} 
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label className="form-label">* CURP:</label>
                            <input type="text" className="form-control" placeholder="CURP" value={menu06Data.populationRegistrationCode} onChange={(e) => setMenu06Data({ ...menu06Data, populationRegistrationCode: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label className="form-label">* No. Credencial:</label>
                            <input type="text" className="form-control" placeholder="Número de credencial" value={menu06Data.credentialNumber} onChange={(e) => setMenu06Data({ ...menu06Data, credentialNumber: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label className="form-label">* Fecha de nacimiento:</label>
                            <input type="date" data-date-format="DD MMMM YYYY" className="form-control" placeholder="" value={menu06Data.dateOfBirth} onChange={(e) => setMenu06Data({ ...menu06Data, dateOfBirth: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label className="form-label">* Domicilio:</label>
                            <input type="text" className="form-control" placeholder="Domicilio completo" value={menu06Data.addressDescription} onChange={(e) => setMenu06Data({ ...menu06Data, addressDescription: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label className="form-label">Referencias (Entre calles):</label>
                            <input type="text" className="form-control" placeholder="Referencias del domicilio" value={menu06Data.addressReferences} onChange={(e) => setMenu06Data({ ...menu06Data, addressReferences: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label className="form-label">* Número de teléfono:</label>
                            <input type="tel" className="form-control" placeholder="1234567890" value={menu06Data.phoneNumber} onChange={(e) => setMenu06Data({ ...menu06Data, phoneNumber: e.target.value })} />
                        </div>
                    </div>
                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={handleAgregar}>{dataEdit != null ? "Editar" : "Crear"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}